export function isLoggingInFromAccountsSubdomain() {
  const hostname = window.location.hostname
  return hostname.startsWith('accounts.')
}
